import { axiosForHybris } from '@telialt/utils/src/axios/axiosForHybris';
import { withParams } from '@telialt/utils/src/helpers';
import { getSegmentSlug, getSiteName, TeliaSegment } from '@telialt/utils/src/segment';

import { API } from './constants';
import { RetailsData } from './model';

export const apiGetRetailsMapSearch = (segment: TeliaSegment, productCode?: string) => {
    const siteName = getSiteName(segment);
    const segmentSlug = getSegmentSlug(segment);

    return axiosForHybris.get<RetailsData>(withParams(API.URL_RETAILS_MAP_SEARCH, { siteName, segmentSlug }), {
        params: { productCode },
    });
};
